module.exports = ".select2-results__option[aria-selected=true] {\n  display: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/forms/form-element/select2/ng2-select2.component.scss
// module id = ./src/app/shared/forms/form-element/select2/ng2-select2.component.scss
// module chunks = main